import React from 'react'
import profile from '../../api/profile.json'

const Home = () => {
  const { bio } = profile
  return (
    <div className="intro text-start mt-4">
      <div
      dangerouslySetInnerHTML={{__html: bio}}
    />
    </div>
  )
}

export default Home